import React from 'react';
import styled from '@emotion/styled';
import Fa from 'components/fa';

const Wrapper = styled.div`
  position: fixed;
  left: ${props => props.left}px;
  top: ${props => props.top}px;
  transform: translate(-50%, -100%);
  z-index: 10000;
  display: ${props => props.visible ? 'flex' : 'none'};
  align-items: center;
  background: #111214;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);
  color: #fff;
  padding: 3px;

  &:after {
    content: '';
    position: absolute;
    left: 50%;
    bottom: -7.5px;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 7.5px solid transparent;
    border-right: 7.5px solid transparent;
    border-top: 7.5px solid #111214;
  }
`;

const ToolbarButton = styled.button`
  appearance: none;
  background: ${props => props.active ? '#3f4248' : 'transparent'};
  border: 0;
  border-radius: 0;
  color: #f2f3f5;
  cursor: pointer;
  font-size: 15px;
  height: 30px;
  line-height: 30px;
  margin: 0;
  padding: 0;
  text-align: center;
  width: 33px;

  &:hover {
    background: #2b2d31;
  }

  .fa {
    color: #f2f3f5 !important;
    font-size: 15px;
    line-height: 30px;
    margin: 0 !important;
  }
`;

const Divider = styled.div`
  background: #2b2d31;
  height: 23px;
  margin: 0 2px;
  width: 1px;
`;

const MarkdownSelectionToolbar = ({
  activeFormats,
  left,
  onFormat,
  onLink,
  onUnlink,
  top,
  visible,
}) => {
  const active = activeFormats || {};

  return (
    <Wrapper
      data-markdown-selection-toolbar
      left={left}
      top={top}
      visible={visible}
      onMouseDown={e => e.preventDefault()}
    >
      <ToolbarButton
        active={active.bold}
        aria-label='Bold'
        title='Bold'
        type='button'
        onClick={() => onFormat('bold')}
      >
        <Fa i='bold' />
      </ToolbarButton>
      <ToolbarButton
        active={active.italic}
        aria-label='Italic'
        title='Italic'
        type='button'
        onClick={() => onFormat('italic')}
      >
        <Fa i='italic' />
      </ToolbarButton>
      <ToolbarButton
        active={active.strikethrough}
        aria-label='Strikethrough'
        title='Strikethrough'
        type='button'
        onClick={() => onFormat('strikethrough')}
      >
        <Fa i='strikethrough' />
      </ToolbarButton>
      <Divider />
      {
        active.link &&
          <ToolbarButton
            active
            aria-label='Unlink'
            title='Unlink'
            type='button'
            onClick={onUnlink}
          >
            <Fa i='chain-broken' />
          </ToolbarButton>
      }
      {
        !active.link &&
          <ToolbarButton
            aria-label='Link'
            title='Link'
            type='button'
            onClick={onLink}
          >
            <Fa i='link' />
          </ToolbarButton>
      }
    </Wrapper>
  );
};

export default MarkdownSelectionToolbar;
